var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCommissionBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_3058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.34755 42.8541H4.04264C4.78685 42.8541 5.39019 42.2507 5.39019 41.5065V26.6835H1.34755C0.603342 26.6835 0 27.2866 0 28.031V41.5065C0 42.2506 0.603342 42.8541 1.34755 42.8541Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3059 30.7804C19.3328 30.7804 28.6399 33.7989 28.6399 33.7989C30.2072 34.2687 31.5997 33.3819 32.0357 32.074C32.4938 30.6455 31.7123 29.1363 30.3109 28.6782L17.6349 24.5278C14.8624 23.5184 11.1262 23.727 8.0853 25.4274V40.5129L18.6591 42.9083C20.596 43.3343 22.4966 43.573 24.3277 43.573H24.6242C29.152 43.519 33.491 42.2345 37.3182 39.9166L44.8374 34.6612C46.104 33.7718 46.3467 32.1009 45.5112 30.9151C44.6488 29.6752 42.9778 29.3788 41.765 30.2413L34.5422 35.3081C32.2244 36.6556 29.3946 36.9521 26.8342 36.0895L18.5243 33.3405C17.8236 33.1249 17.4462 32.3433 17.6888 31.6427C17.9044 30.969 18.6052 30.5917 19.3059 30.7804Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2159 2.42761C29.262 2.42761 24.4355 7.25408 24.4355 13.208C24.4355 19.1617 29.262 23.9884 35.2159 23.9884C41.1698 23.9884 45.9963 19.1617 45.9963 13.208C45.9963 7.25408 41.1698 2.42761 35.2159 2.42761ZM31.847 7.8179C32.5912 7.8179 33.1946 8.42106 33.1946 9.16544C33.1946 9.90965 32.5912 10.513 31.847 10.513C31.1028 10.513 30.4995 9.90965 30.4995 9.16544C30.4995 8.42106 31.1028 7.8179 31.847 7.8179ZM32.8826 18.114C32.4072 18.683 31.5601 18.7636 30.9837 18.2864C30.4126 17.81 30.3349 16.9598 30.8113 16.3874L37.549 8.30211C38.0254 7.73228 38.8756 7.65466 39.448 8.12972C40.0191 8.60612 40.0968 9.45624 39.6204 10.0287L32.8826 18.114ZM38.5848 18.5982C37.8405 18.5982 37.2372 17.9948 37.2372 17.2506C37.2372 16.5063 37.8405 15.9031 38.5848 15.9031C39.329 15.9031 39.9323 16.5063 39.9323 17.2506C39.9323 17.9948 39.329 18.5982 38.5848 18.5982Z",
    fill: "#5BA1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_3058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommissionBlue);
export default __webpack_public_path__ + "static/media/icon-commission-blue.36c00f7d8fe6b7795fdbb8db8c95adc4.svg";
export { ForwardRef as ReactComponent };